import AlgorithmParametersSharedState from './algoParameters/AlgorithmParametersSharedState';

export enum WidgetSharedStateSection {
    ALGORITHM_PARAMETERS = 'ALGORITHM_PARAMETERS',
}

/*
 * This is the state shared between different widget types, not persisted in the layout
 * Do not confuse with WidgetsSharedConfigState
 */
export interface WidgetSharedState {
    [WidgetSharedStateSection.ALGORITHM_PARAMETERS]?: AlgorithmParametersSharedState;
}

export const initialWidgetSharedState: WidgetSharedState = {};
